export enum ToastType {
  INFO = 'info',
  WARNING = 'warning',
  ALERT = 'alert',
  SUCCESS = 'success',
  UPDATE = 'update',
}

export interface ToastAction {
  label: string;
  action: () => void;
}

export interface Toast {
  id: string;
  type: ToastType;
  value?: string;
  actions?: ToastAction[];
  persistent?: boolean;
}
